<template>
  <BootstrapModal class="ProductStock"
    v-on="$listeners"

    @save="saveProductStock"
  >
    <FormInput
      class="form-element"
      v-model="$v.stockCount.$model"

      id="stock_count"
      label="Voorraad"

      :vuelidate="$v"
      fieldName="stockCount"
    />

    <template #title>
      Voorraadtelling bewerken
    </template>
  </BootstrapModal>
  </template>

<script>

import BootstrapModal from "../BootstrapModal.vue"
import FormInput from "src/components/Inputs/FormInput.vue"

import { required } from "vuelidate/lib/validators"

const decimal = value => {
  return (value + "").replace(/,/, ".").match(/^[-]?\d*(\.\d+)?$/) ? true : false
}

export default {
  components: {
    BootstrapModal,
    FormInput,
  },
  props: {
    productStock: {
      type: Object,
      required: false,
    },
  },
  validations: {
    stockCount: {
      decimal,
      required,
    },
  },
  data() {
    return {
      stockCount: "",
    }
  },
  mounted() {
    const cat = this.productStock
    if (cat) {
      this.$v.stockCount.$model = cat.productStock
    }
  },
  methods: {
    saveProductStock() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        stock_count: this.$v.stockCount.$model,
      }

      if (this.productStock) {
        payload.uid = this.productStock.uid
      }

      this.$handlePromise(async () => {
        let message = 'Categorie succesvol toegevoegd!'
        if (!this.productStock) {
          await this.axios.post(`/api/categories`, payload)
        } else {
          message = 'Categorie succesvol opgeslagen!'
          await this.axios.put(`/api/categories/${this.productStock.uid}`, payload)
        }
        this.$store.dispatch('clearCacheSearch', "categories")

        this.$success(message)
        this.callback && this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.ProductStock {
  flex-basis: 400px;
}

</style>
